import { render, staticRenderFns } from "./MainChartTable.vue?vue&type=template&id=23ae0f20&scoped=true&"
import script from "./MainChartTable.vue?vue&type=script&lang=js&"
export * from "./MainChartTable.vue?vue&type=script&lang=js&"
import style0 from "./MainChartTable.vue?vue&type=style&index=0&id=23ae0f20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ae0f20",
  null
  
)

export default component.exports